<div class="legal-documents" *ngIf="hasLegalDocuments()">
  <div class="legal-links">
    <a href="#"
       *ngIf="legalDocuments?.imprint?.content"
       (click)="openModal('imprint', $event)"
       class="legal-link">
      {{ legalDocuments?.imprint?.title || 'Imprint' }}
    </a>
    <span *ngIf="legalDocuments?.imprint?.content && (legalDocuments?.terms?.content || legalDocuments?.privacy?.content)"> | </span>

    <a href="#"
       *ngIf="legalDocuments?.terms?.content"
       (click)="openModal('terms', $event)"
       class="legal-link">
      {{ legalDocuments?.terms?.title || 'Terms' }}
    </a>
    <span *ngIf="legalDocuments?.terms?.content && legalDocuments?.privacy?.content"> | </span>

    <a href="#"
       *ngIf="legalDocuments?.privacy?.content"
       (click)="openModal('privacy', $event)"
       class="legal-link">
      {{ legalDocuments?.privacy?.title || 'Privacy Policy' }}
    </a>
  </div>
</div>

<!-- Modal for legal documents -->
<div class="modal-overlay"
     *ngIf="isModalOpen"
     (click)="closeModal()">
  <div class="modal-content"
       (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>{{ currentDocument?.title }}</h2>
      <button class="close-button" (click)="closeModal()">&times;</button>
    </div>
    <div class="modal-body">
      <div [innerHTML]="currentDocument?.content"></div>
    </div>
  </div>
</div>

